<template>
    <div class="con_stage__side-bauteil" :class="`con_stage__side-bauteil--${bauteil.orientation}`">
        <div class="con_stage__side-text">
            <p v-if="!isMobile" class="subline subline--bold" v-html="bauteil.name"></p>
            <div v-html="bauteil.description"></div>
        </div>
        <div class="con_stage__side-imagewrapper">
            <div class="con_stage__side-imagewrapper__inner">
                <div class="con_stage__side-imagelabel con_stage__side-imagelabel--top">{{ bauteil.label_top }}</div>
                <div class="con_stage__side-image" @click="debugMousePosition">
                    <global-responsive-image :key="bauteil.name" :responsiveImage="bauteil.image" :lazy="false" />
                    <template v-for="(schicht, index) in bauteil.schichten">
                        <div class="con_stage__side-marker-wrapper"
                             :style="getStyleForMarker(schicht.position)"
                             @mouseenter="setSelectSchicht(schicht)"
                             @mouseleave="setSelectSchicht(null)"
                        >
                            <div class="con_stage__side-marker" :class="{'con_stage__side-marker--active': selectedSchicht === schicht}">
                                {{index + 1}}
                            </div>
                        </div>
                    </template>
                </div>
                <div class="con_stage__side-imagelabel con_stage__side-imagelabel--bottom">{{ bauteil.label_bottom }}</div>
            </div>
        </div>
        <ol class="con_stage__side-schichten">
            <li v-for="(schicht, index) in bauteil.schichten"
                class="con_stage__side-schicht"
                :class="{'con_stage__side-schicht--active': selectedSchicht === schicht}"
                @mouseenter="setSelectSchicht(schicht)"
                @mouseleave="setSelectSchicht(null)">
                <div class="con_stage__side-marker"
                     :class="{'con_stage__side-marker--active': selectedSchicht === schicht}"
                >
                    {{index + 1}}
                </div>
                <template v-if="schicht.url">
                    <a :href="schicht.url"
                       target="_blank"
                       class="button button--brand"
                       v-html="schicht.name"
                       @click="handleSchichtClick(schicht)"
                    ></a>
                </template>
                <template v-else>
                    <span v-html="schicht.name"></span>
                </template>
            </li>
        </ol>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import GlobalResponsiveImage from "../../../../../global/global-elements/global-responsive-image/global-responsive-image.vue";
// @ts-ignore
import {detectBreakpoint} from "../../../../../utilities/sal-breakpoint/sal-breakpoint";
import {Bauteil, ResponsivePosition, Schicht, Type} from "./constructionstage.vue";
// @ts-ignore
import {track_abstract, tracking_events} from '../../../../../utilities/track-abstract/track-abstract';

export default Vue.extend({
    name: "constructionstage-bauteil",
    components: {GlobalResponsiveImage},
    props: {
        bauteil: Object as () => Bauteil,
        activeBreakpoint: String
    },
    data() : {
        selectedSchicht: Schicht|null
        trackedSchichtInteraction: boolean
    } {
        return {
            selectedSchicht: null,
            trackedSchichtInteraction: false
        }
    },
    computed: {
        isMobile() : boolean {
            return this.activeBreakpoint === "xs" || this.activeBreakpoint === "sm"
        },
    },
    methods: {
        setSelectSchicht(schicht: Schicht|null) {
            this.selectedSchicht = schicht
            if (!this.trackedSchichtInteraction) {
                track_abstract.trigger_event(tracking_events.ConstructionStageLayerInteraction, this.bauteil.name);
                this.trackedSchichtInteraction = true
            }
        },

        getStyleForMarker(position: ResponsivePosition) {
            const style = {} as {
                top: string
                right: string
                bottom: string
                left: string
            }

            let pos_h = position.xl.horizontal
            if ((this.activeBreakpoint === 'xs' || this.activeBreakpoint === 'sm') && position.xs.horizontal !== '%') {
                pos_h = position.xs.horizontal
            }
            else if (this.activeBreakpoint === 'md' && position.md.horizontal !== '%') {
                pos_h = position.md.horizontal
            }
            else if (this.activeBreakpoint === 'lg' && position.lg.horizontal !== '%') {
                pos_h = position.lg.horizontal
            }

            let pos_v = position.xl.vertical
            if ((this.activeBreakpoint === 'xs' || this.activeBreakpoint === 'sm') && position.xs.vertical !== '%') {
                pos_v = position.xs.vertical
            }
            else if (this.activeBreakpoint === 'md' && position.md.vertical !== '%') {
                pos_v = position.md.vertical
            }
            else if (this.activeBreakpoint === 'lg' && position.lg.vertical !== '%') {
                pos_v = position.lg.vertical
            }

            if (pos_h.startsWith('-')) {
                style["right"] = pos_h.substr(1)
            }
            else {
                style["left"] = pos_h
            }

            if (pos_v.startsWith('-')) {
                style["bottom"] = pos_v.substr(1)
            }
            else {
                style["top"] = pos_v
            }

            return style
        },

        handleSchichtClick(schicht: Schicht) {
            if (schicht) {
                track_abstract.trigger_event(tracking_events.ConstructionStageClickProduct, schicht.name);
            }
        },

        debugMousePosition(event: PointerEvent) {
            // @ts-ignore
            if (window.TYPO3) {
                const clickedElement = event.target as HTMLElement
                const pctTop = event.offsetY / clickedElement.clientHeight * 100
                const pctLeft = event.offsetX / clickedElement.clientWidth * 100

                console.table({
                    ['breakpoint: '+(this.activeBreakpoint === 'sm' ? 'xs' : this.activeBreakpoint)]: {
                        horizontal: (Math.round(pctLeft * 100) / 100).toFixed(2),
                        vertical: (Math.round(pctTop * 100) / 100).toFixed(2)
                    }
                });
            }
        },
    }
})
</script>
